import React from 'react'
import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material'

import type { IntegrationFieldsProps } from '../types'

const VALID_SUBMITTER_FIELDS = [
  { id: 'firstName', label: 'First Name' },
  { id: 'lastName', label: 'Last Name' },
  { id: 'email', label: 'Email' },
  { id: 'phone', label: 'Phone' },
  { id: 'address', label: 'Address' },
  { id: 'address2', label: 'Address Line 2' },
  { id: 'city', label: 'City' },
  { id: 'state', label: 'State' },
  { id: 'zip', label: 'ZIP Code' },
  { id: 'middleInitial', label: 'Middle Initial' },
]

export const DEFAULT_REQUEST311_CONFIG = {
  required_submitter_fields: ['firstName', 'email'],
}

export const Request311EditableFields: React.FC<IntegrationFieldsProps> = ({
  config,
  onChange,
}) => {
  const requiredSubmitterFields =
    (config.required_submitter_fields as string[] | undefined) ||
    DEFAULT_REQUEST311_CONFIG.required_submitter_fields

  const handleToggleField = (fieldId: string): void => {
    const newFields = requiredSubmitterFields.includes(fieldId)
      ? requiredSubmitterFields.filter((f) => f !== fieldId)
      : [...requiredSubmitterFields, fieldId]

    onChange({
      ...config,
      required_submitter_fields: newFields,
    })
  }

  return (
    <Box>
      <Typography variant='subtitle2' sx={{ fontWeight: 600, marginBottom: '8px' }}>
        Required Submitter Fields
      </Typography>
      <Typography variant='body2' sx={{ color: '#666', marginBottom: '12px' }}>
        Select which fields the AI agent must collect from users before creating a service request.
      </Typography>
      <FormGroup sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px' }}>
        {VALID_SUBMITTER_FIELDS.map((field) => (
          <FormControlLabel
            key={field.id}
            control={
              <Checkbox
                checked={requiredSubmitterFields.includes(field.id)}
                onChange={(): void => handleToggleField(field.id)}
                size='small'
              />
            }
            label={<Typography variant='body2'>{field.label}</Typography>}
          />
        ))}
      </FormGroup>
    </Box>
  )
}
